import { render, staticRenderFns } from "./SidebarAd.vue?vue&type=template&id=3480e80c&"
import script from "./SidebarAd.vue?vue&type=script&lang=js&"
export * from "./SidebarAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports